/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  SalesWorkshopItem
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List offerable workshop items for the sales request wizard
 */
export const listSalesWorkshopItems = (

 signal?: AbortSignal
) => {


      return axiosClient<SalesWorkshopItem[]>(
      {url: `/sales/workshop_items`, method: 'GET', signal
    },
      );
    }




export const getListSalesWorkshopItemsQueryKey = () => {
    return [
    'sales','workshop_items'
    ] as const;
    }


export const getListSalesWorkshopItemsQueryOptions = <TData = Awaited<ReturnType<typeof listSalesWorkshopItems>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSalesWorkshopItems>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListSalesWorkshopItemsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSalesWorkshopItems>>> = ({ signal }) => listSalesWorkshopItems(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSalesWorkshopItems>>, TError, TData>
}

export type ListSalesWorkshopItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listSalesWorkshopItems>>>
export type ListSalesWorkshopItemsQueryError = ErrorType<unknown>


/**
 * @summary List offerable workshop items for the sales request wizard
 */

export function useListSalesWorkshopItems<TData = Awaited<ReturnType<typeof listSalesWorkshopItems>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSalesWorkshopItems>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSalesWorkshopItemsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






